var _g, _path, _g2, _circle, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2FerUsc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 28,
    viewBox: "0 0 55 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2796_73773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4975 27.5278C42.4388 27.5278 54.5511 22.8131 54.5511 16.9972C54.5511 11.1812 42.4388 6.46651 27.4975 6.46651C12.5562 6.46651 0.443848 11.1812 0.443848 16.9972C0.443848 22.8131 12.5562 27.5278 27.4975 27.5278Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86346 13.2513C1.54909 14.4609 0.88984 15.728 0.88984 16.9972C0.88984 18.2663 1.54909 19.5334 2.86346 20.743C4.17693 21.9518 6.1033 23.0617 8.52225 24.0033C13.3567 25.8851 20.0652 27.0585 27.4971 27.0585C34.9289 27.0585 41.6374 25.8851 46.4719 24.0033C48.8908 23.0617 50.8172 21.9518 52.1307 20.743C53.445 19.5334 54.1043 18.2663 54.1043 16.9972C54.1043 15.728 53.445 14.4609 52.1307 13.2513C50.8172 12.0426 48.8908 10.9326 46.4719 9.99104C41.6374 8.10922 34.9289 6.93587 27.4971 6.93587C20.0652 6.93587 13.3567 8.10922 8.52225 9.99104C6.1033 10.9326 4.17693 12.0426 2.86346 13.2513ZM8.2123 9.11071C13.1693 7.18118 19.9876 5.99716 27.4971 5.99716C35.0065 5.99716 41.8248 7.18118 46.7818 9.11071C49.2586 10.0748 51.2942 11.234 52.7187 12.545C54.1423 13.8551 54.9971 15.3583 54.9971 16.9972C54.9971 18.636 54.1423 20.1392 52.7187 21.4493C51.2942 22.7603 49.2586 23.9195 46.7818 24.8836C41.8248 26.8131 35.0065 27.9972 27.4971 27.9972C19.9876 27.9972 13.1693 26.8131 8.2123 24.8836C5.73551 23.9195 3.69997 22.7603 2.27547 21.4493C0.851855 20.1392 -0.00292969 18.636 -0.00292969 16.9972C-0.00292969 15.3583 0.851855 13.8551 2.27547 12.545C3.69997 11.234 5.73551 10.0748 8.2123 9.11071Z",
    fill: "url(#paint0_linear_2796_73773)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4974 21.247C36.7251 21.247 44.2057 18.8399 44.2057 15.8707C44.2057 12.9015 36.7251 10.4944 27.4974 10.4944C18.2696 10.4944 10.7891 12.9015 10.7891 15.8707C10.7891 18.8399 18.2696 21.247 27.4974 21.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3638 14.1583C11.5638 14.7669 11.2355 15.3517 11.2355 15.8707C11.2355 16.3897 11.5638 16.9745 12.3638 17.5831C13.1537 18.184 14.3255 18.7447 15.8135 19.2235C18.7842 20.1794 22.9152 20.7776 27.4975 20.7776C32.0798 20.7776 36.2108 20.1794 39.1814 19.2235C40.6695 18.7447 41.8412 18.184 42.6311 17.5831C43.4311 16.9745 43.7594 16.3897 43.7594 15.8707C43.7594 15.3517 43.4311 14.7669 42.6311 14.1583C41.8412 13.5574 40.6695 12.9967 39.1814 12.5179C36.2108 11.5621 32.0798 10.9638 27.4975 10.9638C22.9152 10.9638 18.7842 11.5621 15.8135 12.5179C14.3255 12.9967 13.1537 13.5574 12.3638 14.1583ZM15.5523 11.6203C18.6288 10.6304 22.852 10.0251 27.4975 10.0251C32.1429 10.0251 36.3661 10.6304 39.4427 11.6203C40.9782 12.1144 42.2533 12.7122 43.1544 13.3978C44.0454 14.0755 44.6522 14.9051 44.6522 15.8707C44.6522 16.8363 44.0454 17.6659 43.1544 18.3436C42.2533 19.0292 40.9782 19.627 39.4427 20.1211C36.3661 21.1111 32.1429 21.7163 27.4975 21.7163C22.852 21.7163 18.6288 21.1111 15.5523 20.1211C14.0168 19.627 12.7416 19.0292 11.8405 18.3436C10.9496 17.6659 10.3428 16.8363 10.3428 15.8707C10.3428 14.9051 10.9496 14.0755 11.8405 13.3978C12.7416 12.7122 14.0168 12.1144 15.5523 11.6203Z",
    fill: "url(#paint1_linear_2796_73773)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2796_73773)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2796_73773",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 0H28V16H44V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2796_73773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9802 7.37334C43.6796 3.22 40.0654 -0.0866644 35.8834 2.25147e-06C33.3982 0.0333356 30.9664 1.21334 29.4366 3.39334C28.969 4.05334 29.1293 4.96667 29.7907 5.43334C30.452 5.9 31.3673 5.74 31.8349 5.08C33.0708 3.32667 35.222 2.59334 37.1861 3.07334C39.4107 3.58667 41.0942 5.70667 41.0675 8C41.0675 9.46667 40.4262 10.8667 39.3105 11.8333C38.6959 12.3667 38.6358 13.2867 39.1635 13.9C39.698 14.5133 40.6199 14.5733 41.2345 14.0467C43.1518 12.3933 44.174 9.89334 43.9735 7.38L43.9802 7.37334Z",
    fill: "url(#paint2_linear_2796_73773)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3377 11.08V11.5933C36.3377 11.7933 36.1773 11.96 35.9702 11.96C35.7631 11.96 35.6028 11.8 35.6028 11.5933V11.0867C34.8613 11.0333 34.2667 10.78 33.7991 10.4267C33.6788 10.3333 33.5986 10.18 33.5986 10.0133C33.5986 9.73334 33.8258 9.50668 34.113 9.50668C34.2199 9.50668 34.3335 9.54001 34.4203 9.60668C34.7544 9.85334 35.1418 10.04 35.6095 10.1133V8.34668C34.6608 8.11334 33.6654 7.76001 33.6654 6.57334C33.6654 5.64001 34.427 4.90001 35.6095 4.80001V4.26668C35.6095 4.06668 35.7698 3.90001 35.9769 3.90001C36.184 3.90001 36.3444 4.06001 36.3444 4.26668V4.81334C36.9055 4.86668 37.3865 5.04001 37.8208 5.33334C37.9477 5.42668 38.0412 5.58001 38.0412 5.75334C38.0412 6.02668 37.8141 6.26001 37.5335 6.26001C37.4266 6.26001 37.3264 6.22668 37.2529 6.16668C36.9723 5.97334 36.665 5.85334 36.3444 5.79334V7.36668C37.2997 7.62001 38.3285 7.98001 38.3285 9.20668C38.3218 10.1333 37.7139 10.94 36.3444 11.0733L36.3377 11.08ZM35.6028 7.18001V5.75334C35.0817 5.80668 34.7544 6.09334 34.7544 6.50001C34.7544 6.86001 35.1151 7.04668 35.6028 7.18001ZM37.2262 9.31334C37.2262 8.89334 36.8521 8.70001 36.3377 8.54668V10.12C36.9723 10.0267 37.2262 9.66001 37.2262 9.31334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1897 10.5667C41.5283 10.1 40.613 10.26 40.1454 10.92C39.3638 12.0267 38.1947 12.7667 36.8586 13C35.5224 13.2333 34.173 12.9267 33.064 12.1467C31.8615 11.3 31.0798 9.97333 30.9329 8.50666C30.9128 8.29333 30.8393 8.09333 30.7391 7.91333C30.7659 8.02 30.7859 8.12666 30.7859 8.24C30.7859 8.97333 30.1913 9.56666 29.4565 9.56666C28.7216 9.56666 28.127 8.97333 28.127 8.24C28.127 8.16666 28.1404 8.09333 28.1471 8.02C28.0335 8.25333 27.9801 8.52 28.0068 8.8C28.2406 11.1067 29.4631 13.2 31.3671 14.54C32.7366 15.5 34.3333 16 35.97 16C36.431 16 36.892 15.9667 37.3663 15.88C39.4773 15.52 41.3145 14.3533 42.5504 12.6067C43.018 11.9467 42.8577 11.0333 42.1963 10.5667H42.1897Z",
    fill: "url(#paint3_linear_2796_73773)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4564 9.72667C28.6013 9.72667 28 9.1 28 8.25333C28 7.40667 28.6013 6.78 29.4564 6.78C30.3115 6.78 30.9127 7.40667 30.9127 8.25333C30.9127 9.1 30.3115 9.72667 29.4564 9.72667ZM29.4564 9.28C30.0309 9.28 30.405 8.84 30.405 8.25333C30.405 7.66667 30.0376 7.22667 29.4564 7.22667C28.8752 7.22667 28.5077 7.67333 28.5077 8.25333C28.5077 8.83333 28.8818 9.28 29.4564 9.28Z",
    fill: "url(#paint4_linear_2796_73773)"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 8,
    r: 8,
    fill: "#2775CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 13.5625C26.5 13.75 26.35 13.8562 26.175 13.8C23.75 13.025 22 10.7625 22 8.08125C22 5.40625 23.75 3.1375 26.175 2.3625C26.3562 2.30625 26.5 2.4125 26.5 2.6V3.06875C26.5 3.19375 26.4062 3.3375 26.2875 3.38125C24.3688 4.0875 23 5.93125 23 8.08125C23 10.2375 24.3688 12.075 26.2875 12.775C26.4062 12.8187 26.5 12.9625 26.5 13.0875V13.5625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4998 11.8313C28.4998 11.9688 28.3873 12.0813 28.2498 12.0813H27.7498C27.6123 12.0813 27.4998 11.9688 27.4998 11.8313V11.0438C26.406 10.8938 25.8748 10.2875 25.731 9.45C25.706 9.30625 25.8185 9.18125 25.9623 9.18125H26.531C26.6498 9.18125 26.7498 9.26875 26.7748 9.38125C26.881 9.875 27.1685 10.2563 28.0435 10.2563C28.6873 10.2563 29.1498 9.89375 29.1498 9.35625C29.1498 8.81875 28.881 8.6125 27.931 8.45625C26.531 8.26875 25.8685 7.84375 25.8685 6.75C25.8685 5.90625 26.5123 5.24375 27.4998 5.10625V4.33125C27.4998 4.19375 27.6123 4.08125 27.7498 4.08125H28.2498C28.3873 4.08125 28.4998 4.19375 28.4998 4.33125V5.125C29.306 5.26875 29.8185 5.725 29.9873 6.4875C30.0185 6.63125 29.906 6.7625 29.756 6.7625H29.231C29.1185 6.7625 29.0248 6.6875 28.9935 6.58125C28.8498 6.1 28.506 5.8875 27.906 5.8875C27.2435 5.8875 26.8998 6.20625 26.8998 6.65625C26.8998 7.13125 27.0935 7.36875 28.1123 7.5125C29.4873 7.7 30.1998 8.09375 30.1998 9.2625C30.1998 10.15 29.5373 10.8688 28.506 11.0313V11.8313H28.4998Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.825 13.8C29.6438 13.8562 29.5 13.75 29.5 13.5625V13.0937C29.5 12.9562 29.5812 12.825 29.7125 12.7812C31.625 12.0812 33 10.2375 33 8.08749C33 5.93124 31.6313 4.09374 29.7125 3.39374C29.5938 3.34999 29.5 3.20624 29.5 3.08124V2.61249C29.5 2.42499 29.65 2.31874 29.825 2.37499C32.25 3.13749 34 5.40624 34 8.08124C34 10.7625 32.25 13.025 29.825 13.8Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C24.4181 0 28 3.58192 28 8C28 12.4181 24.4179 16 20 16C15.5821 16 12 12.419 12 8C12 3.58096 15.5814 0 20 0Z",
    fill: "#53AE94"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9876 5.74401V6.93409L20.9882 6.93441C23.1962 7.03633 24.8561 7.47409 24.8561 7.99841C24.8561 8.52273 23.1962 8.96048 20.9882 9.06241V12.8747H19.0202V9.06273C16.809 8.96049 15.145 8.52241 15.145 7.99761C15.145 7.47281 16.8082 7.03473 19.0202 6.93313V5.74401H16.2985V3.93073H23.709V5.74401H20.9876ZM20.9882 8.73856V8.73953L20.9885 8.73873C22.9383 8.65184 24.3943 8.31105 24.3943 7.90529C24.3943 7.49953 22.9389 7.15889 20.9885 7.07201V8.4008C20.9325 8.40593 20.6274 8.43121 20.0205 8.43121C19.5153 8.43121 19.1492 8.40961 19.0212 8.4008V7.07201C17.0671 7.15873 15.6082 7.49856 15.6082 7.90577C15.6082 8.31296 17.0669 8.65329 19.0212 8.73985V8.73825C19.1471 8.74481 19.5044 8.75921 20.0122 8.75921C20.6474 8.75921 20.9327 8.74208 20.9882 8.73856Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2796_73773",
    x1: -0.000224351,
    y1: 16.9972,
    x2: 54.9998,
    y2: 16.9972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#05000B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9540E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2796_73773",
    x1: 10.3455,
    y1: 15.8707,
    x2: 44.6549,
    y2: 15.8707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#05000B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9540E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2796_73773",
    x1: 28.8153,
    y1: 7.2,
    x2: 41.141,
    y2: 7.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#7933D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2796_73773",
    x1: 27.4456,
    y1: 11.96,
    x2: 41.7487,
    y2: 11.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2B58EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7933D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2796_73773",
    x1: 29.4764,
    y1: 9.52667,
    x2: 29.4431,
    y2: 6.80666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2B58EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2796_73773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 22,
    fill: "white",
    transform: "translate(0 6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2796_73773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(28)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2FerUsc);
export default __webpack_public_path__ + "static/media/2fer-usc.b5afe26e9bfcb26775d5db29747e7c11.svg";
export { ForwardRef as ReactComponent };